import WrapperService from "@/modules/core/services/wrapper-service";
import {createPageableParams} from "@/modules/core/services/table-utils";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/task"

const serviceName = "Task-Board-Service: ";
const sortTableFields = ["name"];
const sortDatabaseFields = ["name"];
export default class TaskBoardService {

  static async readAllPaginatedFromAPI(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, sortTableFields, sortDatabaseFields);
    await WrapperService.get(API_URL + '/page', {params: params}, serviceName, successF, errorF);
  }

  static async readAllFilteredPaginatedFromAPI(page, size, search, sort, sortAsc, filter, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, sortTableFields, sortDatabaseFields);
    await WrapperService.post(API_URL + '/page/filter?' + params, filter, serviceName, successF, errorF);
  }

  static async createOrEditTask(task, successF, errorF) {
    let taskId = task.id;

    if (taskId !== null) {
      await WrapperService.put(API_URL + '/' + taskId, task, serviceName, successF, errorF);
    } else {
      await WrapperService.post(API_URL + '/', task, serviceName, successF, errorF);
    }
  }

  static async loadTasks(customer, successF, errorF) {
    await WrapperService.get(API_URL + '/customer/' + customer, null, serviceName, successF, errorF);
  }

  static async readTask(taskId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + taskId, null, serviceName, successF, errorF);
  }

  static async signInvoice(taskId, invoiceId, successF, errorF){
    await WrapperService.get(API_URL + '/sign-invoice/' + taskId + '/' + invoiceId, null, serviceName, successF, errorF);
  }

  static async processInvoice(taskId, invoiceId, successF, errorF){
    await WrapperService.get(API_URL + '/process-invoice/' + taskId + '/' + invoiceId, null, serviceName, successF, errorF);
  }

  static async loadBreadCrumbs(taskId, successF, errorF){
    await WrapperService.get(API_URL + '/bread-crumbs/' + taskId, null, serviceName, successF, errorF)
  }

  static async startTask(taskId, successF, errorF){
    await WrapperService.get(API_URL + '/start-task/' + taskId, null, serviceName, successF, errorF);
  }

  static async finishTask(taskId, successF, errorF) {
    await WrapperService.get(API_URL + '/finish-task/' + taskId, null, serviceName, successF, errorF);
  }

  static async readByTaskCode(taskCode, successF, errorF){
    await WrapperService.get(API_URL + '/code/' + taskCode, null, serviceName, successF, errorF);
  }

  static async loadBoardTasks(customerId, search, userId, successF, errorF){
    let formData = new FormData();
    formData.append("search", search ? search : '');
    formData.append("userId", userId ? userId : '');
    await WrapperService.post(API_URL + '/board/' + customerId, formData, serviceName, successF, errorF);
  }

  static async updateBoardStatus(taskId, boardStatus, successF, errorF){
    await WrapperService.get(API_URL + '/board-status/' + taskId + '/' + boardStatus, null, serviceName, successF, errorF);
  }

  static async loadByFacility(elevatorId, successF, errorF){
    await WrapperService.get(API_URL + '/facility/' + elevatorId, null, serviceName, successF, errorF);
  }
}